<soldo-field-layout
  cypressSelector="Address_GoogleMapsAddressSearch_SearchAddress"
  [control]="searchControl"
  fieldName="googleMapsSearchControl"
  label="{{ searchControlLabel | translate }}">

  <div class="autocomplete-field" input>
    <typeface-icon>search</typeface-icon>
    <ng-select
      [formControl]="searchControl"
      [typeahead]="addressSearchTypeahead"
      [loading]="addressSearchLoading"
      [items]="addressSearchResults"
      dropdownposition="bottom"
      notFoundText="{{ 'REGISTRATION.ADDRESS.SEARCH_NO_RESULT' | translate }}"
      type="search"
      [clearable]=false
      bindLabel="description"
      bindValue="place_id"
      placeholder="{{ searchControlPlaceholder | translate }}">

      @if (noActionableResult) {
        <ng-template ng-header-tmp>
          <p>{{ 'REGISTRATION.ADDRESS.SEARCH_RESULTS_NOT_COMPLETE' | translate }}</p>
        </ng-template>
      }
    </ng-select>
  </div>

</soldo-field-layout>
